import styled from "styled-components";

export const LogoContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img{
        width: ${({width}) => width || '4.5rem'};
        height: ${({height}) => height || '1.8rem'};
    }
    @media only screen and (min-width: 992px) {
        img{
            width: ${({width}) => width || '6rem'};
            height: ${({height}) => height || '2.4rem'};
        }
    }
`